export default "__VITE_ASSET__CYjKokgp__"